<template>
  <ls-table-layout>
    <div class="table-page-operator-wrapper" slot="btn" v-show="false">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['system:post:add']">新增</a-button>
      <a-button @click="handleDeleteBatch(selectedRowKeys)" :disabled="selectedRowKeys.length === 0" v-hasPermi="['system:post:remove']">删除</a-button>
      <a-button @click="handleExport()" v-hasPermi="['system:post:export']">导出</a-button>
    </div>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="岗位编码">
              <a-input placeholder="请输入" v-model="queryParams.postCode"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="岗位名称">
              <a-input placeholder="请输入" v-model="queryParams.postName"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="岗位状态">
              <a-select placeholder="请选择" v-model="queryParams.status">
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="0">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <!-- <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="postId"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.POST_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="status" slot-scope="{ text }">
            <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
          </span>
        </ls-api-table>
        <create-form
          ref="createModal"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { delPost, listPost } from '@/api/system/post'
import CreateForm from './components/CreateForm'
import { generateLsTableResData } from '@/utils/util.js';

const statusMap = {
  0: {
    status: 'default',
    text: '停用'
  },
  1: {
    status: 'processing',
    text: '正常'
  }
}
export default {
  name: 'Post',
  components: {
    CreateForm
  },
  data () {
    return {
       // 表格配置
       tableProps: {
        requestApi: generateLsTableResData(listPost, true),
        pageCurrent: true
      },
      // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: true,
      // 状态数据字典
      statusOptions: [],
      // 岗位表格数据
      postList: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined
      },
      tableLoading: false,
      // 表头
      columns: [
        {
          title: '岗位编号',
          dataIndex: 'postId',
          // width: 180,
          scopedSlots: { customRender: 'postId' }
        },
        {
          title: '岗位编码',
          // width: 180,
          dataIndex: 'postCode'
        },
        {
          title: '岗位名称',
          // width: 120,
          dataIndex: 'postName'
        },
        {
          title: '岗位排序',
          // width: 120,
          dataIndex: 'postSort'
        },
        {
          title: '状态',
          dataIndex: 'status',
          // width: 120,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '创建时间',
          // width: 150,
          dataIndex: 'createTime'
        }
        // {
        //   title: '操作',
        //   width: '150',
        //   dataIndex: 'action',
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      // 表格多选

      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      }
    }
  },
  // 状态过滤
  filters: {
    statusFilter (type) {
      return statusMap[type].text
    },
    statusTypeFilter (type) {
      return statusMap[type].status
    }
  },
  created () {
   // this.getList()
    this.getDicts('sys_normal_disable').then(response => {
      this.statusOptions = response.data
    })
  },
  mounted () {
    this.onSearch();
  },
  methods: {
        /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      },
        // 表单搜索
     onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 查询岗位列表 */
    getList () {
      this.tableLoading = true
      listPost(this.queryParams).then(response => {
        this.postList = response.rows
        this.total = response.total
        this.tableLoading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.pageNum = 1
      this.onSearch();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      const postId = row.postId
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 角色编号为${postId}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delPost(postId).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 批量删除按钮操作 */
    handleDeleteBatch (ids) {
      const postIds = ids
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 角色编号为${postIds}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delPost(postIds).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch();
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch();
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('system/post/export', {
        ...this.queryParams
      }, `post_${new Date().getTime()}.xlsx`)
    }

  }
}
</script>
